<template>
  <div class="lie-box">
    <!-- 全选按钮 -->
    <el-checkbox v-if="(sourceList.length > 0) && (accessPoint['team:delete'] || accessPoint['team:download'])" class="checkbox-all" :disabled="checkAllDisabled" :indeterminate="isIndeterminate" v-model="checkAll"
      @change="handleCheckAllChange">全选</el-checkbox>

    <div class="list-box" :style="{height:listHeight}">
      <!-- 暂无数据提示 -->
      <div v-if="!listLoading && sourceList.length == 0" :style="{width:'100%','line-height':listHeight,'color':'#909399','text-align':'center'}">暂无数据！</div>

      <el-scrollbar wrap-class="scrollbar-wrapper" v-else>
        <!-- 大图列表 -->
        <el-row :gutter="20" class="img-box" v-loading="listLoading">
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="card" v-for="(item,index) in sourceList" :key="index">
            <el-card class="img-item" :class="item.checked ? 'checked-active' : ''" :body-style="{ padding: '0px' }" shadow="hover">
              <div class="img">
                <div class="set-box">
                  <div class="set-left">
                    <el-checkbox v-model="item.checked" @change="handleCheckedItemChange($event,item)" v-if="(item.fileType != 3) && (accessPoint['team:delete'] || accessPoint['team:download'])"></el-checkbox>
                  </div>
                  <div class="set-right">
                    <div class="set-item" @click="item.edit = true" v-if="accessPoint['team:update']">
                      <el-tooltip class="icon-butn" effect="dark" content="重命名" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                        <svg-icon icon-class="edit_shape" />
                      </el-tooltip>
                    </div>

                    <div class="set-item" @click="handleDeleteFolder(item)" v-if="accessPoint['team:delete']">
                      <el-tooltip class="icon-butn" effect="dark" content="删除" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                        <svg-icon icon-class="delete_shape" />
                      </el-tooltip>
                    </div>

                    <!-- <div class="set-item" v-if="item.fileType != 3 && accessPoint['ads:push']" @click="handlePushFolder(item)">
                      <el-tooltip class="icon-butn" effect="dark" content="推送" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                        <svg-icon icon-class="push_shape" />
                      </el-tooltip>
                    </div> -->
                    <!--  && item.inOutStatus!=2 && synchro==2 -->
                    <!-- <div class="set-item" v-if="item.fileType != 3 && item.outFile==false && synchro==2">
                      <el-tooltip class="icon-butn" effect="dark" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                        <span slot="content">同步外网</span>
                        <svg-icon icon-class="synchro" @click="handleSynchro(item)" />
                      </el-tooltip>
                    </div>

                    <div class="set-item" v-show="item.fileType != 3 && item.inOutStatus==1 && synchro==2">
                      <el-tooltip class="icon-butn" effect="dark" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                        <span slot="content">同步外网中,强制重新执行</span>
                        <i class="el-icon-loading" @click="handleSynchroAgain(item)" style="font-size:16px"></i>
                      </el-tooltip>
                    </div> -->
                    <!-- synchro==1 && -->
                    <div class="set-item" v-if=" item.fileType != 3 && accessPoint['team:download']" @click="handleDownloadFolder(item)">
                      <el-tooltip class="icon-butn" effect="dark" content="下载" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                        <svg-icon icon-class="download_shape" />
                      </el-tooltip>
                    </div>
                    <!-- item.outFile && synchro==2 &&-->
                    <!-- <div class="set-item" v-if=" item.fileType != 3 && accessPoint['team:download']" @click="handleDownloadFolder(item)">
                      <el-tooltip class="icon-butn" effect="dark" content="下载" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                        <svg-icon icon-class="download_shape" />
                      </el-tooltip>
                    </div> -->

                  </div>
                </div>

                <!-- 文件夹 -->
                <div class="img-style" v-if="item.fileType == 3" @click="handleOptenFolder(item)">
                  <svg-icon class="icon" icon-class="floder-blue" />
                </div>
                <!-- 视频 或 图片 -->
                <template v-else>
                  <svg-icon class="icon-video" icon-class="play-shape" v-if="item.fileType == 2" @click="handleImageViewer(item)" />
                  <el-image class="img-style" :src="item.thumbnailImageUrl" lazy @click="handleImageViewer(item)">
                    <div slot="error" class="el-image__error image-slot">
                      <i class="el-icon-picture-outline"></i>
                      <span style="line-height:30px">缺少资源</span>
                    </div>
                  </el-image>
                </template>
              </div>

              <div class="text-box">
                <div class="item title">
                  <!-- <label >文件名：</label> -->
                  <span v-if="!item.edit">{{item.fileName}}</span>
                  <template v-else>
                    <el-input v-if="item.fileType == 3" size="mini" v-model="item.fileName" style="width:60%"></el-input>

                    <el-input v-else size="mini" v-model="item.prefixName" style="width:60%"></el-input>

                    <div class="icon-butn" @click="handleSaveName(item)">
                      <i class="el-icon-check"></i>
                    </div>

                    <div class="icon-butn" @click="handleCancel(item)">
                      <i class="el-icon-close"></i>
                    </div>
                  </template>
                </div>

                <div class="item">
                  <!-- <label>{{item.designerName ? '设计师' : '创建人'}}：</label> -->
                  <span :title="item.designerName? item.designerName: item.createUserName">{{item.designerName? item.designerName: item.createUserName}}</span>
                </div>
                <div class="item">
                  <!-- <label>{{item.fileType == 3 ? '创建时间' : '上传时间'}}：</label> -->
                  <span :title="item.createTimeStr">{{item.createTimeStr}}</span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-scrollbar>

    </div>
  </div>
</template>

<script>
import { syncFileInToOut_ajax } from '@File~/api/file'
export default {
  props: {
    // 数据源列表
    sourceList: {
      type: Array,
      default: () => []
    },

    listLoading: {
      type: Boolean,
      default: true
    },

    barHeight: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      synchro: 1,
      accessPoint: this.$store.getters.accessPoint, //权限点
      // 全选
      checkAll: false,
      checkedItem: [],
      isIndeterminate: false,
      checkAllDisabled: false, // 全选按钮是否禁用
      listHeight: '100px'
    }
  },
  created() {
    this.synchro = this.$store.getters.synchro
  },
  methods: {
    // 初始化
    init() {
      const list = this.filterList()
      // console.log('初始化====', list)
      if (list && list.length == 0) {
        this.checkAllDisabled = true
      } else {
        this.checkAllDisabled = false
      }

      this.listHeight = `calc(100vh - 50px - 48px - 115px - ${this.barHeight})`
      // console.log(this.listHeight)
    },

    // 操作全选
    handleCheckAllChange(val) {
      if (val) {
        this.checkAll = true
        this.isIndeterminate = false
        this.checkedItem = this.filterList(val)
        this.$emit('selectionList', this.checkedItem)
      } else {
        this.checkAll = false
        this.checkedItem = []
        this.isIndeterminate = false
        this.filterList(val)
        this.$emit('selectionList', this.checkedItem)
      }
    },

    // 选折文件
    handleCheckedItemChange(val, item) {
      item.checked = val
      if (val) {
        this.checkedItem.push(item)
      } else {
        // console.log(this.checkedItem.indexOf(item))
        this.checkedItem.splice(this.checkedItem.indexOf(item), 1)
      }

      const list = this.filterList()
      if (this.checkedItem.length > 0 && this.checkedItem.length < list.length) {
        this.isIndeterminate = true
        this.checkAll = false
      } else if (this.checkedItem.length == list.length) {
        this.isIndeterminate = false
        this.checkAll = true
      } else if (this.checkedItem.length == 0) {
        this.isIndeterminate = false
        this.checkAll = false
      }
      this.$emit('selectionList', this.checkedItem)
    },

    // 除了文件夹外的所有文件
    filterList(val) {
      const list = []
      this.sourceList.forEach(item => {
        if (item.fileType != 3) {
          list.push(item)
          if (val == true) {
            item.checked = true
          } else if (val == false) {
            item.checked = false
          }

          //   if(item.inOutStatus == 0 && this.synchro==2 && (item.fileType == 1 || item.fileType ==2)){
          //         item.thumbnailImageUrl = ""
          //     }
        }
      })

      return list
    },

    // 取消文件名修改
    handleCancel(item) {
      // console.log('取消===',item)
      this.$emit('cancelFilename', item)
    },

    // 保存文件名修改
    handleSaveName(item) {
      // console.log('保存===',item)
      this.$emit('saveFilename', item)
    },

    // 删除文件
    handleDeleteFolder(item) {
      this.$emit('deleteFolder', item)
    },

    // 下载文件
    handleDownloadFolder(item) {
      // if (item.outFile == false && this.synchro == 2) {
      //   this.$message.warning("请先将文件同步至外网")
      //   return false
      // }
      this.$emit('downloadFolder', item)

    },

    // 推送文件
    handlePushFolder(item) {
      this.$emit('pushFolder', item)
    },

    // 同步文件
    handleSynchro(item) {
      // console.log(item,inOut)
      // console.log('同步文件====')
      this.$confirm('确定要将素材同步到外网吗？', '同步外网', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.synchro_ajax(item)
      }).catch(() => {

      });
    },

    synchro_ajax(item) {
      item.inOutStatus = 1
      const data = {
        "fileId": item.id,
        "userId": this.$store.getters.userId,
        "repeat": 0,//是否强制重新执行 默认：0:不强制重新执行 1:强制重新执行
      }
      // 同步接口
      syncFileInToOut_ajax(data).then(response => {
        if (response.code == 1) {
          if (response.data.inOutStatus != 2) {
            setTimeout(() => {
              this.synchro_ajax(item)
            }, 500);
          } else {
            item.inOutStatus = 2
            this.$message.success(item.fileName + ' 同步完成');
            item.thumbnailImageUrl = response.data.thumbnailImageUrl + "&v=1.1"
          }

        }
      })
    },


    handleSynchroAgain(item) {
      // console.log('同步文件====')
      this.$confirm('强制重新将素材同步到外网吗？', '同步外网', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.inOutStatus = 1
        const data = {
          "fileId": item.id,
          "userId": this.$store.getters.userId,
          "repeat": 1,//是否强制重新执行 默认：0:不强制重新执行 1:强制重新执行
        }
        // 同步接口
        syncFileInToOut_ajax(data).then(response => {
          if (response.code == 1) {
            if (response.data.inOutStatus != 2) {
              setTimeout(() => {
                this.synchro_ajax(item)
              }, 500);
            } else {
              item.inOutStatus = 2
              this.$message.success(item.fileName + ' 同步完成');
              item.thumbnailImageUrl = response.data.thumbnailImageUrl + "&v=1.1"
            }
          }
        })

      }).catch(() => {

      });
    },

    // 打开大图
    handleImageViewer(item) {
      // if (item.outFile == false && this.synchro == 2) {
      //   this.$message.warning("请先将文件同步至外网")
      //   return false
      // }
      this.$emit('imageViewer', item)
    },

    // 打开文件夹
    handleOptenFolder(item) {
      this.$emit('openFolder', item)
    },
  }
}
</script>

<style lang="scss" scoped>
.img-box {
  margin: 0 !important;
  padding: 16px 0 0;
  height: auto;
  overflow: hidden;
  ::v-deep .el-card {
    border: 1px solid #eeeeee;
    font-size: 12px;
    color: #999;
  }
  .img-item {
    margin-bottom: 20px;
  }
  .img {
    height: 140px;
    overflow: hidden;
    padding: 2px 8px;
    background: #f5f5f5;
    position: relative;
  }
  .set-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: 42px;
    padding: 6px;
    overflow: hidden;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
    opacity: 0;
    transition: 0.3s;
    .set-item {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
      margin-left: 4px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .icon-butn {
        width: 16px;
        height: 16px;
        color: #666;
      }
    }
    .set-right {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
      align-items: flex-start;
    }
  }
  .img-style {
    width: 100%;
    height: 100%;
    display: block;
    text-align: center;
    line-height: 140px;
    position: relative;
    cursor: pointer;
    .icon {
      font-size: 125px;
    }
    ::v-deep .el-image__inner {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
    ::v-deep .el-image__inner,
    .icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
    }
    ::v-deep .image-slot {
      flex-flow: column nowrap;
    }
  }
  .icon-video {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 7;
    margin: -25px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    cursor: pointer;
  }
  .text-box {
    height: 80px;
    padding: 4px 12px 8px;
    .item {
      line-height: 1.4;
      width: 100%;
      margin: 4px 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .title {
      margin: 0;
      line-height: 28px;
      font-size: 14px;
      color: #333333;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
    }
    .icon-butn {
      width: 24px;
      height: 24px;
      background: rgba(58, 137, 255, 0.1);
      border-radius: 3px;
      margin-left: 4px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 16px;
        font-weight: 600;
        color: #3a89ff;
      }
    }
  }

  .is-hover-shadow:hover {
    .set-box {
      opacity: 1;
    }
  }

  ::v-deep .el-input__inner {
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border: 1px solid #3a89ff;
    padding: 0 6px;
  }
}

::v-deep .el-checkbox__inner {
  width: 16px;
  height: 16px;
  border: 1px solid #e5e5e5;
  &::after {
    top: 2px;
    left: 5px;
  }
}

.checked-active {
  border: 1px solid #1890ff !important;
  // background-color: #edf9ff !important;
  .img {
    background: #f0f6ff;
    box-shadow: 0px -1px 0px 0px #eeeeee;
  }
  .set-box {
    opacity: 1;
    .set-right {
      opacity: 0;
    }
  }
}

.list-box {
  height: calc(100vh - 50px - 48px - 285px);
}
.scrollbar-wrapper {
  overflow-x: hidden !important;
  width: 100%;
}

::v-deep .el-scrollbar__wrap {
  // width: 100%;
  overflow-x: hidden !important;
}

.el-scrollbar__bar.is-vertical {
  right: 0px;
}

.el-scrollbar {
  height: 100%;
}
</style>